/** Normalize email for lookup keys and matching. */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase()
}

/** Digits-only phone for lookup (India-friendly, keeps last 10 digits). */
export function normalizePhone(phone: string): string {
  const digits = phone.replace(/\D/g, '')
  if (digits.length <= 10) return digits
  return digits.slice(-10)
}

export function emailLookupKey(email: string): string {
  return normalizeEmail(email).replace(/[^a-z0-9]/g, '_')
}

export function phoneLookupKey(phone: string): string {
  const n = normalizePhone(phone)
  return n || 'invalid'
}
